function valoresNumericos(valores = []) {
  return valores.map(Number).filter(Number.isFinite);
}

export function mediaPercentual(valores = []) {
  const validos = valoresNumericos(valores);
  if (!validos.length) return 0;
  return validos.reduce((total, valor) => total + valor, 0) / validos.length;
}

export function mediaPercentualArredondada(valores = []) {
  return Math.round(mediaPercentual(valores));
}

export function calcularExecucaoProjetos(
  projetos = [],
  obterExecucao = (projeto) => projeto?.execucao,
) {
  const idsVistos = new Set();
  const projetosUnicos = projetos.filter((projeto, indice) => {
    const idProjeto = Number(projeto?.idProjeto);
    const chave = Number.isFinite(idProjeto) && idProjeto > 0
      ? `id:${idProjeto}`
      : `indice:${indice}`;
    if (idsVistos.has(chave)) return false;
    idsVistos.add(chave);
    return true;
  });

  return mediaPercentualArredondada(projetosUnicos.map(obterExecucao));
}

export function resultadosOkrDosEixos(eixos = []) {
  return eixos.flatMap((eixo) =>
    (eixo?.objetivosOkr || []).flatMap((objetivo) => objetivo?.resultados || []),
  );
}

export function progressoOkrDosEixos(eixos = []) {
  return mediaPercentual(
    resultadosOkrDosEixos(eixos).map((resultado) => resultado?.percentualAtingido),
  );
}

export function progressoOkrDosPdms(pdms = [], pdmDetalhes = {}) {
  const idsVistos = new Set();
  const resultados = [];

  pdms.forEach((pdm) => {
    const idPdm = Number(pdm?.idPdm);
    if (!Number.isFinite(idPdm) || idsVistos.has(idPdm)) return;
    idsVistos.add(idPdm);
    resultados.push(...resultadosOkrDosEixos(pdmDetalhes[idPdm]?.eixos || []));
  });

  return mediaPercentualArredondada(
    resultados.map((resultado) => resultado?.percentualAtingido),
  );
}
